import { render, staticRenderFns } from "./DiscountParticipation.vue?vue&type=template&id=887815de&"
import script from "./DiscountParticipation.vue?vue&type=script&lang=ts&"
export * from "./DiscountParticipation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports